import { API_ENDPOINTS } from '../constants';

export const PAGE_SIZE = 100;
export const searchDatabase = async (
    name: string,
    term: string,
    filters: string,
    page: number = 1
) => {
    const request = await fetch(
        `${API_ENDPOINTS.search(name)}?currentPage=${page}&pageSize=${PAGE_SIZE}&${
            !filters || term ? `search=${term || '*'}` : ''
        }${filters ? `${term ? '&' : ''}${filters}` : ''}`,
        {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'GET',
        }
    );
    if (request.ok) return {success: true, data: await request.json()};
    else return {success: false};
};
export const searchLogins = async (email: string) => {
    const request = await fetch(`${API_ENDPOINTS.search('~logins')}?email=${email}`, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET'
    });
    if (request.ok) return { success: true, data: await request.json() }
    else return { success: false }
};


// WEBPACK FOOTER //
// ./src/services/search.ts